module.exports = "https://static.wanderu.com/static/media/usa-today.9f25b034.png";